import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Com o padrão do React Query (dados velhos na hora), cada tela que montava buscava tudo de novo: trocar de tela no
  // painel recarregava as listas. Um minuto de validade deixa a troca na hora; o que muda dados invalida na hora
  // (como no dashboard da My Lighthouse). O app das pacientes tem a sua própria regra na consulta "dados".
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 60_000, gcTime: 10 * 60_000, retry: 1 },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Pré-carrega a próxima página quando o mouse passa no link.
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  });

  return router;
};

// Registra o router para os <Link to> e params serem verificados pelo TypeScript.
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
